// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__Y3uni","unreadBadge":"styles_unreadBadge__okYRU","modalContent":"styles_modalContent__DHcrG","modal":"styles_modal__3DcTQ"};